import React from 'react';
import CountryItemSource from '../CountryItemSource/';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';

interface DataSourceCountry {
	alpha2: string;
	name: string;
}

interface DataSource {
	country: DataSourceCountry;
	shortName: string;
}

interface SourceList {
	dataSource: DataSource;
	lastUpdateAt: Date;
	type: string;
}

interface Props {
	name: string;
	sourcelist: SourceList[];
	variant: null | string;
}

export default function CountryItem({ name, sourcelist, variant = 'blue' }: Props) {
	let alpha2name = '';
	sourcelist.map((item) => (alpha2name = item.dataSource.country.alpha2));

	return (
		<li className='rounded-md border border-gray-200 bg-gray-50'>
			<div
				className={`px-2.5 py-2 rounded-t border-b border-gray-200 ${
					variant === 'white' ? 'text-white bg-cPurple-600' : 'text-black bg-cPurple-500 bg-opacity-20'
				}`}
			>
				<h5 className='flex justify-between items-center font-semibold'>
					<div className='inline-flex items-center text-md'>
						<CountryIcon code={alpha2name} name={name} className='w-4 h-4 mr-1.5' />
						{name}
					</div>
					<span
						className={`px-1.5 py-0.5 rounded-sm text-label ${
							variant === 'white' ? 'text-gray-100 bg-white bg-opacity-10' : 'text-gray-700 bg-white'
						}`}
					>
						{alpha2name}
					</span>
				</h5>
			</div>
			<div className='px-2.5 divide-y divide-gray-200'>
				{sourcelist.map((item) => (
					<CountryItemSource
						key={item.dataSource.shortName.replace(/[\s,]+/g, '-').toLowerCase()}
						name={item.dataSource.shortName}
						date={item.lastUpdateAt}
						validtype={item.type}
					/>
				))}
			</div>
		</li>
	);
}
